/* eslint-disable */
import React, { useEffect } from 'react';
import B2bLanding from './B2bLanding';
import './b2bPage.css';
import gammaThemeStyles from './b2bGammaTheme.module.css';

/**
 * B2B page always shows the public landing. Cabinet is reached via "Enter cabinet" (opens in new tab).
 * No redirect from /b2b to cabinet.
 */
export default function B2bPage() {
  useEffect(() => {
    document.body.classList.add('b2b-route');
    const layout = document.getElementById('layout');
    layout?.classList.add('b2b-route-layout');
    return () => {
      document.body.classList.remove('b2b-route');
      layout?.classList.remove('b2b-route-layout');
    };
  }, []);

  return (
    <div className={gammaThemeStyles.b2bPageRoot}>
      <B2bLanding />
    </div>
  );
}
